import { useBrainStore } from '@/state/brainStore';
import { useSimulationStore } from '@/state/simulationStore';
import { Sparkles, Hand } from 'lucide-react';
import type { AIConversation } from '@/domain/types';

interface Props {
  aiConvo: AIConversation;
  customerFirstName: string;
}

const STATE_COPY: Record<AIConversation['state'], string> = {
  greeting: 'Greeting customer',
  qualifying: 'Qualifying intent',
  'asking-deposit': 'Asking for deposit',
  closing: 'Closing the booking',
  'hand-off-requested': 'Awaiting handoff',
  resolved: 'Resolved',
  paused: 'Paused',
};

export default function LiveAIBanner({ aiConvo, customerFirstName }: Props) {
  const upsertAIConversation = useBrainStore((s) => s.upsertAIConversation);
  const clockIso = useSimulationStore((s) => s.clockIso);

  const takeOver = () => {
    upsertAIConversation({
      ...aiConvo,
      state: 'paused',
      lastMessageAt: clockIso,
    });
  };

  return (
    <section
      data-testid="live-ai-banner"
      className="rounded-lg border border-gold-bright/40 bg-gold/10 px-5 py-4 mb-4"
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <Sparkles size={16} className="text-gold-bright" />
          <div>
            <p className="label-small-caps text-gold-bright">
              AI is working on {customerFirstName}
            </p>
            <p className="font-inter text-[11px] text-cream-soft mt-0.5 uppercase tracking-widest">
              {STATE_COPY[aiConvo.state]} · {aiConvo.playbookProgressPct}% ·{' '}
              {aiConvo.channel}
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={takeOver}
          className="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs rounded-md border border-gold-bright text-gold-bright hover:bg-gold-bright/15 transition"
          data-testid="ai-take-over"
        >
          <Hand size={12} /> Take over
        </button>
      </div>
      {aiConvo.handoffSuggestedOpener ? (
        <p className="mt-3 font-serif text-sm text-cream-soft border-l-2 border-gold-bright/40 pl-3">
          Suggested opener: &quot;{aiConvo.handoffSuggestedOpener}&quot;
        </p>
      ) : null}
    </section>
  );
}
